import React from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import './ImpactStoriesSection.css';
import img1 from '../images/801A8733.jpg';
import img2 from '../images/801A0469.jpg';
import img3 from '../images/801A0068.jpg';
import img4 from '../images/801A9717.jpg';
import img5 from '../images/801A9645.jpg';
import img6 from '../images/801A0279.jpg';
import img7 from '../images/801A0256.jpg';
import img8 from '../images/801A0077.jpg';
import img9 from '../images/GF surgery 21 .jpg';
import img10 from '../images/GF CLinic 2018 _2.jpg';
import img11 from '../images/GF.jpg';
import img12 from '../images/GF 2022 .jpg';
import img13 from '../images/GF team 3.jpg';
import img14 from '../images/11aba71e-e2b8-432a-93d0-5b8f0cd3204f.jpeg';
import img15 from '../images/Gundeti_Foundation_Hospital_work.jpeg';

const ImpactStoriesSection = () => {
  const impactStories = [
    { img: img1, title: 'Story 1' },
    { img: img2, title: 'Story 2' },
    { img: img3, title: 'Story 3' },
    { img: img4, title: 'Story 4' },
    { img: img5, title: 'Story 5' },
    { img: img6, title: 'Story 6' },
    { img: img7, title: 'Story 7' },
    { img: img8, title: 'Story 8' },
    { img: img9, title: 'Story 9' },
    { img: img10, title: 'Story 10' },
    { img: img11, title: 'Story 11' },
    { img: img12, title: 'Story 12' },
    { img: img13, title: 'Story 13' },
    { img: img14, title: 'Story 14' },
    { img: img15, title: 'Story 15' },
  ];

  return (
    <Box
      className="impact-stories-container"
      sx={{
        background: '#f9f9f9',
        borderRadius: '2.5rem',
        maxWidth: 1100,
        mx: 'auto',
        my: 4,
        p: { xs: 2, md: 6 },
        fontFamily: 'Poppins, Arial, sans-serif',
        color: '#222',
        boxShadow: '0 2px 16px 0 rgba(0,0,0,0.04)',
      }}
    >
      <Typography className="impact-stories-title" variant="h4" sx={{ fontWeight: 900, color: '#222', mb: 4, textAlign: 'center', letterSpacing: 1 }}>
        Impact Stories
      </Typography>
      <Grid className="impact-stories-grid" container spacing={3} justifyContent="center">
        {impactStories.slice(0, 9).map((story, idx) => (
          <Grid className="impact-stories-item" item xs={12} sm={6} md={4} key={idx} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              className="impact-stories-card"
              sx={{
                width: '100%',
                height: 200,
                borderRadius: 3,
                overflow: 'hidden',
                boxShadow: 3,
                transition: 'transform 0.3s, box-shadow 0.3s',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
              }}
            >
              <img
                src={story.img}
                alt={story.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box className="impact-stories-button-container" sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          className="impact-stories-button"
          component={Link}
          to="/gallery"
          variant="outlined"
          sx={{ fontWeight: 700, borderRadius: 999, px: 4 }}
        >
          More
        </Button>
      </Box>
    </Box>
  );
};

export default ImpactStoriesSection;